var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-button",
        {
          staticClass: "md-fab",
          on: {
            click: function($event) {
              return _vm.goBack()
            }
          }
        },
        [_c("md-icon", [_vm._v("arrow_back")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center",
                  attrs: { xl: "9", lg: "9", md: "7", sm: "7", cols: "7" }
                },
                [
                  _c(
                    "v-avatar",
                    {
                      staticClass: "ma-3 tech-icon",
                      attrs: { size: "100", tile: "" }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/uploads/" + _vm.technology.image
                        },
                        on: { error: _vm.setAltImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("h2", [_vm._v(_vm._s(_vm.technology.name))])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center justify-end",
                  attrs: { xl: "3", lg: "3", md: "5", sm: "5", cols: "5" }
                },
                [
                  _vm.loggedIn
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-fab md-primary",
                          on: {
                            click: function($event) {
                              _vm.showDialog = true
                            }
                          }
                        },
                        [
                          _c("md-icon", [_vm._v("bookmarks")]),
                          _vm._v(" "),
                          _c(
                            "md-tooltip",
                            { attrs: { "md-direction": "left" } },
                            [
                              _vm._v(
                                _vm._s(_vm.technology.name) +
                                  " zum Unternehmensprofil\n            hinzufügen"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { xl: "7", lg: "7", md: "7", sm: "6", cols: "12" } },
                [
                  _c("p", {
                    staticClass: "tech-describtion",
                    domProps: { innerHTML: _vm._s(_vm.technology.description) }
                  }),
                  _vm._v(" "),
                  _vm.technology.category == "Assistenzsysteme"
                    ? _c(
                        "v-card",
                        {
                          staticClass: "assistenz-card",
                          attrs: { raised: "true" }
                        },
                        [
                          _c("v-card-title", [_c("h5", [_vm._v("Details")])]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "chipWrapper ml-3" },
                            [
                              _vm.technology.fundamental
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1",
                                      attrs: { label: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Grundlegend\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.technology.intelligent
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1",
                                      attrs: { label: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Intelligent\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.technology.interactive
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1",
                                      attrs: { label: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Interaktiv\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.technology.proactive
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1",
                                      attrs: { label: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Vorausschauend\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-simple-table", {
                            staticClass: "assistent-table mt-3",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c("td", [_vm._v("Einsatzform")]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "primary--text font-weight-bold"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.technology.insertForm
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [_vm._v("Einsatzzweck")]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "primary--text font-weight-bold"
                                            },
                                            _vm._l(
                                              _vm.technology.intendedUse,
                                              function(list, index) {
                                                return _c(
                                                  "span",
                                                  { key: list.index },
                                                  [
                                                    _c("span", [
                                                      _vm._v(_vm._s(list))
                                                    ]),
                                                    _vm._v(" "),
                                                    index + 1 <
                                                    _vm.technology.intendedUse
                                                      .length
                                                      ? _c("span", [
                                                          _vm._v(
                                                            ",\n                      "
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [_vm._v("Medium")]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "primary--text font-weight-bold"
                                            },
                                            _vm._l(
                                              _vm.technology.medium,
                                              function(list, index) {
                                                return _c(
                                                  "span",
                                                  { key: list.index },
                                                  [
                                                    _c("span", [
                                                      _vm._v(_vm._s(list))
                                                    ]),
                                                    _vm._v(" "),
                                                    index + 1 <
                                                    _vm.technology.medium.length
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "/\n                      "
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ])
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2675616729
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "d-flex justify-space-between flex-wrap" },
                    [
                      _c(
                        "div",
                        { staticClass: "tagWrapper" },
                        [
                          _c("h4", { staticClass: "pl-3" }, [
                            _vm._v("Übergeordnete Technologien")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.technology.parents, function(parent) {
                            return _c(
                              "div",
                              { key: parent.hash },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "no-link",
                                    attrs: {
                                      to: {
                                        name: "TechnologyDetail",
                                        params: { hash: parent.hash }
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-chip",
                                      {
                                        staticClass: "ma-2 white--text",
                                        attrs: { color: "#9a2a28" }
                                      },
                                      [_vm._v(_vm._s(parent.name))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _vm.technology.parents.length == 0
                            ? _c("div", [
                                _c(
                                  "h5",
                                  { staticClass: "mt-2 ml-3 red--text" },
                                  [_vm._v("Keine")]
                                )
                              ])
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tagWrapper" },
                        [
                          _c("h4", { staticClass: "pl-3" }, [
                            _vm._v("Untergeordnete Technologien")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.technology.children, function(child) {
                            return _c(
                              "div",
                              { key: child.hash },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "TechnologyDetail",
                                        params: { hash: child.hash }
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-chip",
                                      {
                                        staticClass: "ma-2 white--text",
                                        attrs: { color: "#9a2a28" }
                                      },
                                      [_vm._v(_vm._s(child.name))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _vm.technology.children.length == 0
                            ? _c("div", [
                                _c(
                                  "h5",
                                  { staticClass: "mt-2 ml-3 red--text" },
                                  [_vm._v("Keine")]
                                )
                              ])
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tagWrapper" },
                        [
                          _c("h4", { staticClass: "pl-3" }, [_vm._v("Tags")]),
                          _vm._v(" "),
                          _vm._l(_vm.technology.tags, function(tag) {
                            return _c(
                              "div",
                              { key: tag.hash },
                              [
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2",
                                    attrs: { color: "primary" }
                                  },
                                  [_vm._v(_vm._s(tag.name))]
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _vm.technology.tags.length == 0
                            ? _c("div", [
                                _c(
                                  "h5",
                                  { staticClass: "mt-2 ml-3 red--text" },
                                  [_vm._v("Keine")]
                                )
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "d-flex justify-end pl-5",
                  attrs: { xl: "5", lg: "5", md: "5", sm: "6", cols: "12" }
                },
                [
                  _c(
                    "v-card",
                    { attrs: { raised: "true" } },
                    [
                      _c(
                        "v-list",
                        [
                          _c("v-subheader", { staticClass: "black--text" }, [
                            _c("h3", [_c("b", [_vm._v("Referenzprojekte ")])])
                          ]),
                          _vm._v(" "),
                          _vm.technology.projects.length == 0
                            ? _c(
                                "v-list-item-group",
                                { staticClass: "red--text" },
                                [
                                  _c(
                                    "v-list-item",
                                    [
                                      _c("v-icon", { staticClass: "mr-2" }, [
                                        _vm._v("error")
                                      ]),
                                      _vm._v(
                                        "Keine passenden\n                Referenzprojekte\n              "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.technology.projects.length > 0
                            ? _c(
                                "v-list-item-group",
                                { attrs: { color: "primary" } },
                                _vm._l(_vm.technology.projects, function(
                                  project
                                ) {
                                  return _c(
                                    "v-list-item",
                                    { key: project.hash },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "no-link",
                                              attrs: {
                                                to: {
                                                  name:
                                                    "ReferenceProjectDetail",
                                                  params: { hash: project.hash }
                                                }
                                              }
                                            },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(_vm._s(project.name))
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        [
                          _c("v-subheader", { staticClass: "black--text" }, [
                            _c("h3", [
                              _c("b", [_vm._v("Geschäftsmodellaspekte ")])
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.bmarecommendations.length == 0
                            ? _c(
                                "v-list-item-group",
                                { staticClass: "red--text" },
                                [
                                  _c(
                                    "v-list-item",
                                    [
                                      _c("v-icon", { staticClass: "mr-2" }, [
                                        _vm._v("error")
                                      ]),
                                      _vm._v(
                                        "Keine passenden\n                Referenzprojekte\n              "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.bmarecommendations.length > 0
                            ? _c(
                                "v-list-item-group",
                                { attrs: { color: "primary" } },
                                _vm._l(_vm.bmarecommendations, function(bma) {
                                  return _c(
                                    "v-list-item",
                                    { key: bma.hash },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "no-link",
                                              attrs: {
                                                to: {
                                                  name: "BusinessModelDetail",
                                                  params: { hash: bma.hash }
                                                }
                                              }
                                            },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(_vm._s(bma.name))
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-10 md-medium-size-15 md-small-size-100 md-xsmall-size-100"
      }),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.showDialog },
          on: {
            "update:mdActive": function($event) {
              _vm.showDialog = $event
            },
            "update:md-active": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _c("md-dialog-title", [
            _vm._v("\n      Möchten Sie\n      "),
            _c("b", [_vm._v(_vm._s(_vm.technology.name))]),
            _vm._v(" zu Ihrem Profil hinzufügen?\n    ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "md-layout md-gutter md-alignment-center-center",
              staticStyle: { margin: "5px" }
            },
            [
              _c("div", { staticClass: "md-layout-item md-size-100" }, [
                _vm._v("\n        Hier können Sie\n        "),
                _c("b", [_vm._v(_vm._s(_vm.technology.name))]),
                _vm._v(
                  " Ihrem Unternehmensprofil hinzufügen oder\n        aus Ihrem Profil entfernen. Sie können angeben, dass Sie diese\n        Technologie anbieten oder nach einem Partner suchen, der diese\n        Technologie anbietet.\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("md-dialog-actions", [
            _c(
              "div",
              { staticClass: "md-layout md-gutter md-alignment-center-center" },
              [
                _c(
                  "div",
                  { staticClass: "md-layout-item md-size-100" },
                  [
                    !_vm.request
                      ? _c(
                          "md-button",
                          {
                            staticClass: "md-primary md-raised",
                            on: {
                              click: function($event) {
                                return _vm.addRequest()
                              }
                            }
                          },
                          [_vm._v("Ich suche diese Technologie")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.offer
                      ? _c(
                          "md-button",
                          {
                            staticClass: "md-primary md-raised",
                            on: {
                              click: function($event) {
                                return _vm.addOffer()
                              }
                            }
                          },
                          [_vm._v("Ich biete diese Technologie an")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.request
                      ? _c(
                          "md-button",
                          {
                            staticClass: "md-primary md-raised",
                            on: {
                              click: function($event) {
                                return _vm.removeRequest()
                              }
                            }
                          },
                          [_vm._v("Ich suche diese Technologie nicht mehr")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.offer
                      ? _c(
                          "md-button",
                          {
                            staticClass: "md-primary md-raised",
                            on: {
                              click: function($event) {
                                return _vm.removeOffer()
                              }
                            }
                          },
                          [_vm._v("Ich biete diese Technologie nicht mehr an")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "md-layout-item md-size-100" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-accent",
                        on: {
                          click: function($event) {
                            _vm.showDialog = false
                          }
                        }
                      },
                      [_vm._v("Abbrechen")]
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm.adding
            ? _c("md-progress-bar", {
                staticStyle: { margin: "10px" },
                attrs: { "md-mode": "query" }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62230332", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62230332","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/technologysearch/detail/TechnologyDetail.vue
// module id = null
// module chunks = 